import React from "react";
import StyledTable from "../StyledTable/StyledTable";
import {
  Container,
  DynamicTitle,
  Header,
  TableContainer,
  Title,
} from "./Dashboard.styles";

import { Link } from "react-router-dom";
import ActionBtnU from "../../screens/User/Users/components/ActionBtnU";
import { IoMdArrowRoundBack } from "react-icons/io";

const DashboardComponent = ({
  title,
  columns,
  data,
  isLoading,
  facilitiesData,
  incidentStatusData,
  incidentTypeData,
  doAddIncident,
  getUserCb,
  hasTag,
  tagPosition,
  handleNextPage,
  handlePreviousPage,
  currentPage,
  isFetching,
  serverPaginated,
  noOfPages,
  goToFirstPage,
  goToLastPage,
  handlePageSize,
  showFilterComponent,
}: any) => {
  // show other parts of the dashboard component based on the title of the current component
  let dynamicProps = {
    showDateComponent: true,
    showSelectFacilitiesComponent: true,
    showAddIncidentButton: true,
    showFilterBtn: true,
  };
  return (
    <Container>
      <ActionBtnU
        borderStyle="1px solid rgb(181, 128, 255)"
        color="rgb(181, 128, 255)"
        onClick={() => window.history.back()}
      >
        <span className="mr-2 mt-1 font-bold">
          <IoMdArrowRoundBack />
        </span>
        Back
      </ActionBtnU>
      <Header>
        <Title>
          <Link to="/user/dashboard">Dashboard</Link>
          <DynamicTitle>/ {title}</DynamicTitle>
        </Title>
      </Header>

      <TableContainer>
        <StyledTable
          tableCols={columns}
          tableData={data}
          facilitiesData={facilitiesData}
          incidentTypeData={incidentTypeData}
          incidentStatusData={incidentStatusData}
          isLoading={isLoading}
          // showSearchBar
          doAddIncident={doAddIncident}
          getUserCb={getUserCb}
          {...(title === "Incidents" ? dynamicProps : null)}
          hasTag={hasTag}
          tagPosition={tagPosition}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          serverPaginated={serverPaginated}
          currentPage={currentPage}
          noOfPages={noOfPages}
          isFetching={isFetching}
          goToFirstPage={goToFirstPage}
          goToLastPage={goToLastPage}
          handlePageSize={handlePageSize}
          showFilterComponent={showFilterComponent}
        />
      </TableContainer>
    </Container>
  );
};

export default DashboardComponent;
